import {
  GERMAN,
  ENGLISH_UK,
  ENGLISH_US,
  knownLocales,
  FRENCH_FRANCE,
} from 'constants/locales';

export const isEnglish = (locale) =>
  [ENGLISH_US, ENGLISH_UK]
    .map((l) => l.toLowerCase())
    .includes(locale.toLowerCase());

export const isEnglishUS = (locale) =>
  locale.toLowerCase() === ENGLISH_US.toLowerCase();

export const isGerman = (locale) =>
  locale.toLowerCase() === GERMAN.toLowerCase();

export const isFrench = (locale) =>
  locale.toLowerCase() === FRENCH_FRANCE.toLowerCase();

export const extractPrefix = (url, defaultPrefix = '') => {
  const foundLocale = knownLocales.find((locale) =>
    url.match(new RegExp(`^/${locale.toLowerCase()}`)),
  );

  return foundLocale ? `/${foundLocale.toLowerCase()}/` : defaultPrefix;
};

const generateRegex = () =>
  knownLocales
    .map((locale) => locale.toLowerCase())
    .reduce((acc, knownLocale) => {
      if (acc.length === 0) {
        return `^/${knownLocale}/*`;
      }

      return `${acc}|/${knownLocale}/*`;
    }, '');

const localesRegExp = () => new RegExp(`${generateRegex()}`, 'gi');

export const removeLocaleFromUrl = (url) => url.replace(localesRegExp(), '/');

export const containsLocale = (url) => localesRegExp().test(url);

export const externalLink = (link) =>
  !!(
    link &&
    (link.startsWith('http://') ||
      link.startsWith('https://') ||
      link.startsWith('mailto:'))
  );

export const localizeUrl = (matchUrl, url) => {
  if (externalLink(url)) return url;

  const cleanUrl = `/${url}`.replace(/\/{2,}/, '/');

  if (!containsLocale(matchUrl)) {
    return cleanUrl;
  }

  if (containsLocale(cleanUrl)) {
    return cleanUrl;
  }

  return `${extractPrefix(matchUrl)}${cleanUrl}`.replace('//', '/');
};

export const localizeWithCurrentUrl = (url) => {
  return localizeUrl(window.location.pathname, url);
};

export const getLanguageFromLocale = (locale) => {
  const regex = new RegExp(
    '([a-zA-Z]{2,3}(-([A-Za-z]{3}(-[A-Za-z]{3}){0,2}))?)',
  );

  const result = regex.exec(locale);

  return result && result[0];
};
